import { BadgeWithTooltip } from '../../../BadgeWithTooltip';
import { TabLayout } from '../../TabLayout';
import { TourPageActionButtons } from '../TourPageActionButtons';
import { TourPageBreadcrumbs } from '../TourPageBreadcrumbs';
import { useTourPageProps } from '../TourPageContext';
import { TourPageTitle } from '../TourPageTitle';
import { ActivityOverTime } from './ActivityOverTime';
import { SessionsBreakdownCard } from './SessionsBreakdownCard';

export const ActivitiesTab = () => {
  const { readOnly } = useTourPageProps();
  return (
    <TabLayout
      title={<TourPageTitle />}
      entity="tour"
      breadcrumbs={<TourPageBreadcrumbs />}
      actionButtons={<TourPageActionButtons />}
      secondaryActionButtons={
        readOnly ? (
          <div className="flex items-center gap-1">
            <BadgeWithTooltip
              tooltipText="This asset is shared from another workspace. You can view and present it."
              badgeProps={{
                label: 'Read only',
                variant: 'primary',
              }}
            />
          </div>
        ) : null
      }
    >
      <div className="flex flex-col gap-6">
        <div className="h-[300px]">
          <ActivityOverTime />
        </div>
        <SessionsBreakdownCard />
      </div>
    </TabLayout>
  );
};
